import React from 'react';
import { Button } from '@els/els-react--button';
import { dispatchOpenMolecularModal } from '@Containers/MolecularModal/MolecularModalActions';
import PropTypes from 'prop-types';

function MolecularFormulaLink({ onMolecularFormulaChange }) {
  /** Update value in Query after selection Molecule from Dialog */
  function updateStringTypeDataValue(value) {
    if (!value.length) {
      return;
    }
    onMolecularFormulaChange(value);
  }

  return (
    <Button
      key="molecularformula"
      type="link"
      className="c-els-link--with-icon c-els-link-vertical-temp"
      onClick={() => dispatchOpenMolecularModal({ updateStringTypeDataValue })}>
      <span className="c-els-link__icon icon__wrapper">
        <svg
          viewBox="0 0 104 128"
          aria-hidden="true"
          focusable="false"
          className="icon o-els-icon-svg o-els-icon-svg--1x1o2 o-els-icon-svg--middle o-els-icon-svg--font-offset"
          role="img">
          <use xlinkHref="#icon-molecular-formula" />
        </svg>
      </span>
    </Button>
  );
}
MolecularFormulaLink.propTypes = {
  onMolecularFormulaChange: PropTypes.func,
};
export default MolecularFormulaLink;
